var map = {
	"./14-07-22.md": 17849,
	"./15-07-22.md": 36546,
	"pages/ChangeLog/ChangeLogArchives/14-07-22.md": 17849,
	"pages/ChangeLog/ChangeLogArchives/15-07-22.md": 36546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20585;